<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

@if (!!dataSource && !!dataSource.data && dataSource.data.length > 0) {
  <div
    class="d-flex flex-column"
    >
    <mat-card appearance="outlined" class="module-heading flex-fill w-100 h-100">
      <span><strong>MODULES</strong></span>
      <div class="module-search">
        <mat-form-field class="search-input">
          <mat-icon matPrefix svgIcon="ic_magnify_search"></mat-icon>
          <input
            matInput
            [(ngModel)]="filterString"
            (keyup)="applyFilter($event.target.value)"
            placeholder="Search"
            />
          @if (filterString != '') {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
              <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    </mat-card>
    @for (module of dataSource.filteredData; track module) {
      <mat-card
        appearance="outlined"
        class="clickable highlight module-card flex-fill w-100 h-100"
        (click)="selectModuleFn(module)"
        [matTooltip]="isEditing ? null : 'Edit this file to insert the module'"
        >
        <mat-card-header>
          <mat-card-title class="d-flex flex-column">
            <div>
              <span class="module-name"
                ><strong>{{ module.name }}</strong></span
                >
              </div>
              <div>
                <span class="module-path">{{ module.path }}</span>
              </div>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            {{ module.description }}
          </mat-card-content>
        </mat-card>
      }
    </div>
  }

  <!-- Variables Dialog -->
  <ng-template #variablesDialog>
    <cas-module-variables
      [selectedModule]="_selectedModule"
      [readOnly]="!isEditing"
      submitButtonText="Insert"
      [requireChanges]="false"
      (variablesSelected)="variablesSelected($event)"
      >
    </cas-module-variables>
  </ng-template>
